import { usePromotionTracking } from '../../data-layer/hooks/usePromotionTracking';

export const handleBrazeInAppMessage = (inAppMessage) => {
  const { trackPromotionView, trackPromotionSelect } = usePromotionTracking({
    componentName: 'in_app_message',
  });

  trackPromotionView(inAppMessage.analyticsData);

  inAppMessage.buttons?.forEach((button) => {
    button.subscribeToClickedEvent(() => {
      trackPromotionSelect(inAppMessage.analyticsData);
    });
  });
};
